<template>
  <div class="integralExchange">
    <ul class="exChoose">
      <li :class="this.activeIndex === 1?'activeSearch':''" @click="changeSearch(1, 200, 1)">1-200分</li>
      <li :class="this.activeIndex === 2?'activeSearch':''" @click="changeSearch(201, 500, 2)">201-500分</li>
      <li :class="this.activeIndex === 3?'activeSearch':''" @click="changeSearch(501, 1000, 3)">501-1000分</li>
      <li :class="this.activeIndex === 4?'activeSearch':''" @click="changeSearch(1001, null, 4)">1000分以上</li>
    </ul>
    <div class="exDivide"></div>
    <div class="exShop">
      <ul class="exlist">
        <li
          style="margin-bottom:20px;"
          v-for="(item, index) in exList"
          :key="index"
          @click="jumpGoodDetail(item)"
        >
          <img :src="item.thumbnailUrl?item.thumbnailUrl:'static/img/占位图.png'" width="195px" height="210px" alt="暂无图片"/>
          <p
            class="overell"
            style="
              font-weight: bold;
              font-size: 16px;
            ">
            {{item.commodityName}}
          </p>
          <div style="display: flex;">
            <p class="exgrey" style="flex: 1;">
              所需积分:{{item.needIntegral}}
            </p>
            <p class="exgrey" style="padding-right: 4px;">
              热销数量:{{item.count?item.count:'0'}}
            </p>
          </div>
          <div style="display: flex;">
            <p class="exgrey" style="flex: 1;">
              商品库存:{{item.integralCommodityInventory || 0}}
            </p>
          </div>
        </li>
      </ul>
      <div v-if="exList && exList.length !== 0" class="doclist-pagination">
        <div class="doclist-lastpage" @click="jumpLastPage">上一页</div>
        <div class="doclist-omit">{{lastOmit}}</div>
        <ul>
          <li :class="item === currentPage?'pageactive':'pageDeavtive'" v-for="(item, index) in pageList" :key="index" @click="changePageTo(item)">{{item}}</li>
        </ul>
        <div class="doclist-omit">{{nextOmit}}</div>
        <div class="doclist-nextpage" @click="jumpNextPage">下一页</div>
        <div class="doclist-pagejump">共{{totalPage}}页，到第<input type="text" v-model.number="jumpTargetPage">页</div>
        <div class="doclist-jump" @click="jumpFarPage">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      exList: null,
      start: 1,
      end: 200,
      activeIndex: 1,
      // 分页
      currentPage: 1, // 当前页
      totalPage: 4, // 总页数
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1 // 跳转页
    }
  },
  methods: {
    jumpGoodDetail (item) {
      this.$router.push({
        name: 'exchangeGoodDetail',
        query: {
          id: item.id
        }
      })
    },
    changeSearch (start, end, index) {
      this.currentPage = 1
      this.$http.post(`/front/train/forum/integralExchangeCommodity/frontCommodityList`, {
        page: this.currentPage,
        limit: 10,
        start: start,
        end: end
      })
        .then(({ data }) => {
          if (data.code !== 0 || data.data.data.length === 0) {
            this.$message.warning('抱歉，该分类下暂无可兑换商品，请选择其他分类')
          } else {
            this.start = start
            this.end = end
            this.activeIndex = index
            this.exList = data.data.data
            this.totalPage = Math.ceil(data.data.count / 10)
            let newPageList = []
            if (this.totalPage <= 5) {
              for (let i = 1; i <= this.totalPage; i++) {
                newPageList.push(i)
              }
              this.pageList = newPageList
              this.nextOmit = ''
            }
          }
        })
        .catch(() => {
          // this.$message.error(error.response.data.message)
        })
    },
    // 上一页
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    //  下一页
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    //   第几页
    changePageTo (page) {
      window.scrollTo(0, 0)
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
      this.getExchangeGoodsList()
    },
    //   确定跳转到哪页
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        if (this.totalPage > 5) {
          if (this.jumpTargetPage > 2 && this.jumpTargetPage < this.totalPage - 4) {
            var newPageList3 = []
            for (let index = this.jumpTargetPage - 2; index < this.jumpTargetPage + 3; index++) {
              newPageList3.push(index)
            }
            this.pageList = newPageList3
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = '...'
          } else if (this.jumpTargetPage <= 2) {
            this.pageList = [1, 2, 3, 4, 5]
            this.currentPage = this.jumpTargetPage
            this.lastOmit = ''
            if (this.jumpTargetPage > this.totalPage - 3) {
              this.nextOmit = ''
            } else {
              this.nextOmit = '...'
            }
          } else {
            var newPageList4 = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage]
            this.pageList = newPageList4
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = ''
          }
        } else {
          var newPageList5 = []
          for (let index = 1; index <= this.totalPage; index++) {
            newPageList5.push(index)
          }
          this.pageList = newPageList5
          this.lastOmit = ''
          this.nextOmit = ''
          this.currentPage = this.jumpTargetPage
        }
        this.getExchangeGoodsList()
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    getExchangeGoodsList () {
      this.$http.post(`/front/train/forum/integralExchangeCommodity/frontCommodityList`, {
        page: this.currentPage,
        limit: 10,
        start: this.start,
        end: this.end
      })
        .then(({ data }) => {
          if (data.code === 0) {
            this.exList = data.data.data || []
            this.totalPage = Math.ceil(data.data.count / 10)
            let newPageList = []
            if (this.totalPage <= 5) {
              for (let i = 1; i <= this.totalPage; i++) {
                newPageList.push(i)
              }
              this.pageList = newPageList
              this.nextOmit = ''
            }
          }
        })
        .catch(() => {
          // this.$message.error(error.response.data.message)
        })
    }
  },
  created () {
    this.getExchangeGoodsList()
  }
}
</script>

<style scoped>
.integralExchange{
  width: 1190px;
  background: #ffffff;
  padding-bottom: 40px;
}
.exChoose{
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #333333;
  display: flex;
}
.exChoose .activeSearch{
  background: #1D65A8;
  color: #ffffff;
}
.exChoose li{
  width: 121px;
  text-align: center;
  user-select: none;
  cursor: pointer;
}
.exDivide{
  width: 1190px;
  height: 11px;
  background: #f9f9f9;
}
.exShop{
  width: 1190px;
  background: #ffffff;
}
.exlist{
  width: 1190px;
  padding-top: 40px;
  padding-left: 50px;
  padding-right: 60px;
  display: flex;
  flex-wrap: wrap;
}
.exlist li{
  width: 195px;
  height: 303px;
  margin-left: 20px;
  user-select: none;
  cursor: pointer;
}
.exlist li img{
  width: 195px;
  height: 210px;
}
.exlistDescribe{
  height: 90px;
  line-height: 23px;
  font-size: 14px;
  color: #333333;
  padding-top: 12px;
  font-weight: normal;
  overflow: hidden;
  word-break:break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.exlist p{
}
.exlist .exgrey{
  color: #999999;
  margin: 0;
}
/* 分页区域样式 */
.doclist-pagination .pageactive{
  background: #1D65A8;
  color: #ffffff;
  border: 0;
}
.doclist-pagination{
  margin-top: 30px;
  display: flex;
  height: 40px;
  line-height: 40px;
  text-align: center;
  /* padding-left: 245px; */
}
.doclist-pagination ul{
  display: flex;
}
.doclist-pagination ul li{
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
  cursor: pointer;
  border: 1px solid #eeeeee;
}
.doclist-omit{
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
}
.doclist-lastpage{
  font-size: 14px;
  color: #666666;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-nextpage{
  font-size: 12px;
  color: #666666;
  margin-right: 34px;
  margin-left: 18px;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-pagejump{
  height: 40px;
  color: #999999;
  font-size: 14px;
  margin-right: 46px;
}
.doclist-pagejump input{
  width: 35px;
  height: 40px;
  box-sizing: border-box;
  margin-left: 14px;
  margin-right: 8px;
  width: 34px;
  border: 1px solid #e4e4e4;
  text-align: center;
}
.doclist-jump{
  color: #666666;
  font-size: 14px;
  user-select: none;
  cursor: pointer;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-lastpage{
  user-select: none;
  cursor: pointer;
}
.doclist-nextpage{
  user-select: none;
  cursor: pointer;
}
.pageDeavtive{
  box-sizing: border-box;
  border: 1px solid #eeeeee;
}
/* 分页区域样式结束 */
</style>
